/**
 * Format date from YYYY-MM-DD to readable format (e.g., "January 15, 1985")
 * Uses local timezone to avoid UTC conversion issues
 */
export const formatDateOfBirth = (dateStr) => {
  if (!dateStr) return '';
  try {
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return dateStr;
  }
};
